import { Directive } from '@angular/core';

@Directive({
  selector: '[etAtomsSelectIcon]',
  standalone: false,
})
export class EtSelectIconDirective {}
